import unifyComponents from "../../helpers/components/unifyComponents";
import unwrapNodes from "../../helpers/unwrapNodes";
import calculateQuantityAvailable from "../../helpers/components/calculateQuantityAvailable";
import stockMessage from "../../helpers/stockMessage/stockMessage";

const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

export default function allocateComponents(cartData) {
  let allocatedComponents = {};

  const items = [...cartData.items].reverse();

  items.forEach((item) => {
    const metafields = deepCopy(item.metafields);
    const components = metafields.components.map((component) => ({
      ...component,
      id: `gid://shopify/ProductVariant/${component.id}`,
    }));

    const multiComponents = unwrapNodes(
      metafields.multiComponents.map((component) => {
        component.variant.id = `gid://shopify/ProductVariant/${component.variant.id}`;
        return component;
      }),
    );

    const unifiedComponents = unifyComponents({
      variant: {
        id: `gid://shopify/ProductVariant/${item.variant_id}`,
        availableForSale: item.available_for_sale,
        quantityAvailable: item.quantity_available,
      },
      components,
      multiComponents,
    });

    const result = calculateQuantityAvailable({
      allocatedComponents,
      components: unifiedComponents,
      quantityAvailable: item.quantity_available,
      quantityRequested: item.quantity,
    });

    allocatedComponents = result.allocatedComponents;

    const stockMessageInputs = {
      availableForSale: item.available_for_sale,
      quantityAvailable: result.calculatedQuantityAvailable - item.quantity + 1,
      lowStockThreshold: item.metafields.lowStockThreshold,
      dnr: item.metafields.dnr,
      cargoReady: item.metafields.cargoReady,
      backorderDate: item.metafields.backorderDate,
    };

    item.stockMessageInputs = stockMessageInputs;

    const messages = {
      inStock: {
        limit: null,
      },
      lowStock: {
        limit: null,
      },
      outOfStock: {
        limit: result.calculatedQuantityAvailable,
      },
      reserveNow: {
        limit: null,
      },
      reserveNowDate: {
        limit: null,
      },
      notifyMe: {
        limit: result.calculatedQuantityAvailable,
      },
      notifyMeDate: {
        limit: result.calculatedQuantityAvailable,
      },
    };

    const { limit } = stockMessage({
      availableForSale: item.available_for_sale,
      // Set to 0 because we want to find out the limit when you hit OOS
      quantityAvailable: 0,
      lowStockThreshold: item.metafields.lowStockThreshold,
      dnr: item.metafields.dnr,
      cargoReady: item.metafields.cargoReady,
      backorderDate: item.metafields.backorderDate,
      messages,
    });

    item.cartQuantityLimit = limit;
  });

  cartData.allocatedComponents = allocatedComponents;

  return cartData;
}
